export default __webpack_public_path__ + "static/media/img_post2_1.056b5bf7.png";